import { Injectable } from '@angular/core';

// repo and credit to: https://github.com/PawelDecowski/jQuery-CreditCardValidator/

// var b = creditService.validateCardNumber('5418426187097565');
// var b = creditService.validateCardExpiry('10','15');
// var b = creditService.validateCardCVC(123,'visa');
// var b = creditService.parseCardType('5418426187097565');
// var b = creditService.parseCardExpiry('10/2016');
// var b = creditService.formatCardNumber('5418 4261 8709 7565');
// var b = creditService.formatCardNumber('5418-4261-8709 7565');
// var b = creditService.formatCardExpiry('1/16');

function customIndexOf (this: any, item) {
  for (let i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }

  return -1;
}

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {
  private credit;

  constructor() {
    const creditCardValidator = () => {
      const indexOf = [].indexOf || customIndexOf.bind(this);
      return (function(name, definition) {
        return definition();
      })('cc', function() {
        const _getCaretPos = function(this: any, ele) {
          let r, rc, re;
          if (ele.selectionStart != null) {
            return ele.selectionStart;
          } else if (document['selection'] != null) {
            ele.focus();
            r = document['selection'].createRange();
            re = ele.createTextRange();
            rc = re.duplicate();
            re.moveToBookmark(r.getBookmark());
            rc.setEndPoint('EndToStart', re);
            return rc.text.length;
          }
        };
        const _eventNormalize = function(this: any, listener) {
          return function(e) {
            if (e == null) {
              e = window.event;
            }
            e.target = e.target || e.srcElement;
            e.which = e.which || e.keyCode;
            if (e.preventDefault == null) {
              e.preventDefault = function() {
                return (this.returnValue = false);
              };
            }
            return listener(e);
          };
        };
        const _on = function(ele, event, listener) {
          listener = _eventNormalize(listener);
          if (ele.addEventListener != null) {
            return ele.addEventListener(event, listener, false);
          } else {
            return ele.attachEvent('on' + event, listener);
          }
        };
        const payform: any = {};
        const defaultFormat = /(\d{1,4})/g;
        payform.cards = [
          // {
          //   type: 'elo',
          //   pattern: /^4011|438935|45(1416|76)|50(4175|6699|67|90[4-7])|63(6297|6368)/,
          //   format: defaultFormat,
          //   length: [16],
          //   cvcLength: [3],
          //   luhn: true
          // },
          {
            type: 'visaelectron',
            pattern: /^4(026|17500|405|508|844|91[37])/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
          },
          {
            type: 'maestro',
            pattern: /^(5(018|0[23]|[68])|6(39|7))/,
            format: defaultFormat,
            length: [12, 13, 14, 15, 16, 17, 18, 19],
            cvcLength: [3],
            luhn: true
          },
          {
            type: 'forbrugsforeningen',
            pattern: /^600/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
          },
          {
            type: 'dankort',
            pattern: /^5019/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
          },
          {
            type: 'visa',
            pattern: /^4/,
            format: defaultFormat,
            length: [13, 16],
            cvcLength: [3],
            luhn: true
          },
          {
            type: 'mastercard',
            pattern: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
          },
          {
            type: 'amex',
            pattern: /^3[47]/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
            length: [15],
            cvcLength: [3, 4],
            luhn: true
          },
          {
            type: 'dinersclub',
            pattern: /^3[0689]/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
            length: [14],
            cvcLength: [3],
            luhn: true
          },
          {
            type: 'discover',
            pattern: /^6([045]|22)/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
          },
          {
            type: 'unionpay',
            pattern: /^(62|88)/,
            format: defaultFormat,
            length: [16, 17, 18, 19],
            cvcLength: [3],
            luhn: false
          },
          {
            type: 'jcb',
            pattern: /^35/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
          }
        ];
        const cardFromNumber = function(num) {
          let card, i, len;

          num = (num + '').replace(/\D/g, '');
          const ref = payform.cards;
          for (i = 0, len = ref.length; i < len; i++) {
            card = ref[i];
            if (card.pattern.test(num)) {
              return card;
            }
          }
        };
        const cardFromType = function(type) {
          let card, i, len;
          const ref = payform.cards;
          for (i = 0, len = ref.length; i < len; i++) {
            card = ref[i];
            if (card.type === type) {
              return card;
            }
          }
        };
        const luhnCheck = function(num) {
          let digit, i, len, odd, sum;
          odd = true;
          sum = 0;
          const digits = (num + '').split('').reverse();
          for (i = 0, len = digits.length; i < len; i++) {
            digit = digits[i];
            digit = parseInt(digit, 10);
            if ((odd = !odd)) {
              digit *= 2;
            }
            if (digit > 9) {
              digit -= 9;
            }
            sum += digit;
          }
          return sum % 10 === 0;
        };
        const hasTextSelected = function(this: any, target) {
          let ref;
          if (
            (typeof document !== 'undefined' && document !== null
              ? (ref = document['selection']) != null
                ? ref.createRange
                : void 0
              : void 0) != null
          ) {
            if (document['selection'].createRange().text) {
              return true;
            }
          }
          return (
            target.selectionStart != null && target.selectionStart !== target.selectionEnd
          );
        };
        const replaceFullWidthChars = function(str) {
          let char, i, idx, len, value;
          if (str == null) {
            str = '';
          }
          const fullWidth = '\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19';
          const halfWidth = '0123456789';
          value = '';
          const chars = str.split('');
          for (i = 0, len = chars.length; i < len; i++) {
            char = chars[i];
            idx = fullWidth.indexOf(char);
            if (idx > -1) {
              char = halfWidth[idx];
            }
            value += char;
          }
          return value;
        };
        const reFormatCardNumber = function(e) {
          const cursor = _getCaretPos(e.target);
          e.target.value = payform.formatCardNumber(e.target.value);
          if (cursor != null && e.type !== 'change') {
            return e.target.setSelectionRange(cursor, cursor);
          }
        };
        const formatCardNumber = function(e) {
          let re, upperLength;
          const digit = String.fromCharCode(e.which);
          if (!/^\d+$/.test(digit)) {
            return undefined;
          }
          const value = e.target.value;
          const card = cardFromNumber(value + digit);
          const length = (value.replace(/\D/g, '') + digit).length;
          upperLength = 16;
          if (card) {
            upperLength = card.length[card.length.length - 1];
          }
          if (length >= upperLength) {
            return undefined;
          }
          const cursor = _getCaretPos(e.target);
          if (cursor && cursor !== value.length) {
            return undefined;
          }
          if (card && card.type === 'amex') {
            re = /^(\d{4}|\d{4}\s\d{6})$/;
          } else {
            re = /(?:^|\s)(\d{4})$/;
          }
          if (re.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
              return (e.target.value = value + ' ' + digit);
            });
          } else if (re.test(value + digit)) {
            e.preventDefault();
            return setTimeout(function() {
              return (e.target.value = value + digit + ' ');
            });
          }
          return undefined;
        };
        const formatBackCardNumber = function(e) {
          const value = e.target.value;
          if (e.which !== 8) {
            return undefined;
          }
          const cursor = _getCaretPos(e.target);
          if (cursor && cursor !== value.length) {
            return undefined;
          }
          if (/\d\s$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
              return (e.target.value = value.replace(/\d\s$/, ''));
            });
          } else if (/\s\d?$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
              return (e.target.value = value.replace(/\d$/, ''));
            });
          }
          return undefined;
        };
        const reFormatExpiry = function(e) {
          const cursor = _getCaretPos(e.target);
          e.target.value = payform.formatCardExpiry(e.target.value);
          if (cursor != null && e.type !== 'change') {
            return e.target.setSelectionRange(cursor, cursor);
          }
        };
        const formatCardExpiry = function(e) {
          const digit = String.fromCharCode(e.which);
          if (!/^\d+$/.test(digit)) {
            return undefined;
          }
          const val = e.target.value + digit;
          if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
            e.preventDefault();
            return setTimeout(function() {
              return (e.target.value = '0' + val + ' / ');
            });
          } else if (/^\d\d$/.test(val)) {
            e.preventDefault();
            return setTimeout(function() {
              return (e.target.value = val + ' / ');
            });
          }

          return undefined;
        };
        const formatForwardExpiry = function(e) {
          const digit = String.fromCharCode(e.which);
          if (!/^\d+$/.test(digit)) {
            return undefined;
          }
          const val = e.target.value;
          if (/^\d\d$/.test(val)) {
            return (e.target.value = val + ' / ');
          }
          return undefined;
        };
        const formatForwardSlashAndSpace = function(e) {
          const which = String.fromCharCode(e.which);
          if (!(which === '/' || which === ' ')) {
            return undefined;
          }
          const val = e.target.value;
          if (/^\d$/.test(val) && val !== '0') {
            return (e.target.value = '0' + val + ' / ');
          }
          return undefined;
        };
        const formatBackExpiry = function(e) {
          const value = e.target.value;
          if (e.which !== 8) {
            return undefined;
          }
          const cursor = _getCaretPos(e.target);
          if (cursor && cursor !== value.length) {
            return undefined;
          }
          if (/\d\s\/\s$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
              return (e.target.value = value.replace(/\d\s\/\s$/, ''));
            });
          }
          return undefined;
        };
        const reFormatCVC = function(e) {
          const cursor = _getCaretPos(e.target);
          e.target.value = replaceFullWidthChars(e.target.value)
            .replace(/\D/g, '')
            .slice(0, 4);
          if (cursor != null && e.type !== 'change') {
            return e.target.setSelectionRange(cursor, cursor);
          }
        };
        const restrictNumeric = function(e) {
          if (e.metaKey || e.ctrlKey) {
            return;
          }
          if (e.which === 0) {
            return;
          }
          if (e.which < 33) {
            return;
          }
          const input = String.fromCharCode(e.which);
          if (!/^\d+$/.test(input)) {
            return e.preventDefault();
          }
        };
        const restrictCardNumber = function(e) {
          const digit = String.fromCharCode(e.which);
          if (!/^\d+$/.test(digit)) {
            return;
          }
          if (hasTextSelected(e.target)) {
            return;
          }
          const value = (e.target.value + digit).replace(/\D/g, '');
          const card = cardFromNumber(value);
          if (card && value.length > card.length[card.length.length - 1]) {
            return e.preventDefault();
          } else if (value.length > 16) {
            return e.preventDefault();
          }
        };
        const restrictExpiry = function(e) {
          let value;
          const digit = String.fromCharCode(e.which);
          if (!/^\d+$/.test(digit)) {
            return;
          }
          if (hasTextSelected(e.target)) {
            return;
          }
          value = e.target.value + digit;
          value = value.replace(/\D/g, '');
          if (value.length > 6) {
            return e.preventDefault();
          }
        };
        const restrictCVC = function(e) {
          const digit = String.fromCharCode(e.which);
          if (!/^\d+$/.test(digit)) {
            return;
          }
          if (hasTextSelected(e.target)) {
            return;
          }
          const val = e.target.value + digit;
          if (val.length > 4) {
            return e.preventDefault();
          }
        };
        payform.cvcInput = function(input) {
          _on(input, 'keypress', restrictNumeric);
          _on(input, 'keypress', restrictCVC);
          _on(input, 'paste', reFormatCVC);
          _on(input, 'change', reFormatCVC);
          return _on(input, 'input', reFormatCVC);
        };
        payform.expiryInput = function(input) {
          _on(input, 'keypress', restrictNumeric);
          _on(input, 'keypress', restrictExpiry);
          _on(input, 'keypress', formatCardExpiry);
          _on(input, 'keypress', formatForwardSlashAndSpace);
          _on(input, 'keypress', formatForwardExpiry);
          _on(input, 'keydown', formatBackExpiry);
          _on(input, 'change', reFormatExpiry);
          return _on(input, 'input', reFormatExpiry);
        };
        payform.cardNumberInput = function(input) {
          _on(input, 'keypress', restrictNumeric);
          _on(input, 'keypress', restrictCardNumber);
          _on(input, 'keypress', formatCardNumber);
          _on(input, 'keydown', formatBackCardNumber);
          _on(input, 'paste', reFormatCardNumber);
          _on(input, 'change', reFormatCardNumber);
          return _on(input, 'input', reFormatCardNumber);
        };
        payform.numericInput = function(input) {
          _on(input, 'keypress', restrictNumeric);
          _on(input, 'paste', restrictNumeric);
          _on(input, 'change', restrictNumeric);
          return _on(input, 'input', restrictNumeric);
        };
        payform.parseCardExpiry = function(value) {
          let month, prefix, ref, year;
          value = value.replace(/\s/g, '');
          (ref = value.split('/', 2)), (month = ref[0]), (year = ref[1]);
          if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
            prefix = new Date().getFullYear();
            prefix = prefix.toString().slice(0, 2);
            year = prefix + year;
          }
          month = parseInt(month, 10);
          year = parseInt(year, 10);
          return {
            month: month,
            year: year
          };
        };
        payform.validateCardNumber = function(num) {
          let ref;
          const notFound = { type: null, valid: false };
          num = (num + '').replace(/\s+|-/g, '');
          if (!/^\d+$/.test(num)) {
            return notFound;
          }
          const card = cardFromNumber(num);
          if (!card) {
            return notFound;
          }
          return {
            type: card.type,
            valid:
              ((ref = num.length), indexOf.call(card.length, ref) >= 0) &&
              (card.luhn === false || luhnCheck(num))
          };
        };
        payform.validateCardExpiry = function(month, year) {
          let ref;
          if (typeof month === 'object' && 'month' in month) {
            (ref = month), (month = ref.month), (year = ref.year);
          }
          if (!(month && year)) {
            return false;
          }
          month = String(month).trim();
          year = String(year).trim();
          if (!/^\d+$/.test(month)) {
            return false;
          }
          if (!/^\d+$/.test(year)) {
            return false;
          }
          if (!(1 <= month && month <= 12)) {
            return false;
          }
          if (year.length === 2) {
            if (year < 70) {
              year = '20' + year;
            } else {
              year = '19' + year;
            }
          }
          if (year.length !== 4) {
            return false;
          }
          const expiry = new Date(year, month);
          const currentTime = new Date();
          expiry.setMonth(expiry.getMonth() - 1);
          expiry.setMonth(expiry.getMonth() + 1, 1);
          return expiry > currentTime;
        };
        payform.validateCardCVC = function(cvc, type) {
          let ref;
          cvc = String(cvc).trim();
          if (!/^\d+$/.test(cvc)) {
            return false;
          }
          const card = cardFromType(type);
          if (card != null) {
            return (ref = cvc.length), indexOf.call(card.cvcLength, ref) >= 0;
          } else {
            return cvc.length >= 3 && cvc.length <= 4;
          }
        };
        payform.parseCardType = function(num) {
          let ref;
          if (!num) {
            return null;
          }
          return ((ref = cardFromNumber(num)) != null ? ref.type : void 0) || null;
        };
        payform.formatCardNumber = function(num) {
          let groups, ref;
          num = replaceFullWidthChars(num);
          num = num.replace(/\D/g, '');
          const card = cardFromNumber(num);
          if (!card) {
            return num;
          }
          const upperLength = card.length[card.length.length - 1];
          num = num.slice(0, upperLength);
          if (card.format.global) {
            return (ref = num.match(card.format)) != null ? ref.join(' ') : void 0;
          } else {
            groups = card.format.exec(num);
            if (groups == null) {
              return;
            }
            groups.shift();
            groups = groups.filter(Boolean);
            return groups.join(' ');
          }
        };
        payform.formatCardExpiry = function(expiry) {
          let mon, sep;
          expiry = replaceFullWidthChars(expiry);
          const parts = expiry.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/);
          if (!parts) {
            return '';
          }
          mon = parts[1] || '';
          sep = parts[2] || '';
          const year = parts[3] || '';
          if (year.length > 0) {
            sep = ' / ';
          } else if (sep === ' /') {
            mon = mon.substring(0, 1);
            sep = '';
          } else if (mon.length === 2 || sep.length > 0) {
            sep = ' / ';
          } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
            mon = '0' + mon;
            sep = ' / ';
          }
          return mon + sep + year;
        };
        return payform;
      });
    };
    this.credit = creditCardValidator.call(this)
  }

  public validateCardNumber(cardNumber): { type: string; valid: boolean } {
    return this.credit.validateCardNumber(cardNumber);
  }

  public validateCardExpiry(month, year): boolean {
    return this.credit.validateCardExpiry(month, year);
  }

  public validateCardCVC(cvc, type): boolean {
    return this.credit.validateCardCVC(cvc, type);
  }

  public parseCardType(cardNumber): boolean {
    return this.credit.parseCardType(cardNumber);
  }

  public parseCardExpiry(value): boolean {
    return this.credit.parseCardExpiry(value);
  }

  public formatCardNumber(value): boolean {
    return this.credit.formatCardNumber(value);
  }

  public formatCardExpiry(expiry): boolean {
    const result = this.credit.formatCardExpiry(expiry);
    return result;
  }
}
